module.exports = __webpack_public_path__ + "static/adegunle-3879bccef8ef2c7f2176f0a7eac51c00.jpg";